import React, { useEffect, useState, useRef } from 'react'
import { Formik } from 'formik'
import {
  CaricamentoLoghi,
  NomeLavorazione,
  PosizioneStampa,
  TipoConfezionamento,
  ConfigurazioneStampa,
} from './Steps/index'
import { api } from '../../../utils'
import { PERSONALIZZAZIONI, PRODOTTI, PERSONALIZZAZIONICARRELLO } from '../../../utils/endpoint'
import Button from '../../atoms/Button/Button'
import StepItem from '../../molecules/StepItem/StepItem'
import NewModal from '../../molecules/NewModal/NewModal'
import { Clipboard } from '../../atoms/NewIcons'
import Alert from '../../atoms/Alert/Alert'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import Link from 'next/link'
import { _uploadLoghi } from '../UploadLoghi/UploadLoghi'
import useTrans from '../../../hooks/useTrans'
import * as yup from 'yup'
import { useRouter } from 'next/router'
import { trackingGAEventProdotto } from '../../../utils/gtm'
import { handleScrollRef } from '../../../utils/safe'
import * as Sentry from '@sentry/browser'

const _renderStep = (
  step,
  props,
  setStep,
  Obj,
  setShowModal,
  isPage,
  initialValues,
  ErroreQuantita,
  withLogoFromProps,
  prodotto,
  setReload
) => {
  const t = useTrans()
  const configurazioneStampaItemRef = useRef()

  return (
    <>
      <StepItem
        recap={
          step > 0 && (
            <p>
              {props.values?.posizioni && props.values.posizioni.length > 1
                ? t('2 Posizioni')
                : t('1 Posizione')}{' '}
              {props.values?.posizioni &&
                props.values.posizioni.length > 1 &&
                !props.values?.stesso_logo &&
                t('con loghi diversi')}
            </p>
          )
        }
        setStep={setStep}
        Modificabile={step > 0 ? true : false}
        stepNumber={1}
        placeholder={t('Posizione Stampa')}
        isDisabled={step < 0 ? true : false}
        open={step === 0 ? true : false}
      >
        <PosizioneStampa
          props={props}
          setStep={setStep}
          step={step}
          initialValues={initialValues}
          nPosizioni={Obj.numero_posizioni}
        />
      </StepItem>
      <div ref={configurazioneStampaItemRef}></div>
      <StepItem
        isDisabled={step < 1 ? true : false}
        recap={
          step > 1 && (
            <div
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
            >
              {props.values?.posizioni && (
                <div>
                  <strong>{t('Posizione 1')}</strong>
                  <p>{props.values?.posizioni[0]?.tecnica?.nome}</p>
                  <p>{props.values?.posizioni[0]?.posizione?.nome}</p>
                  {props.values?.posizioni?.[0]?.altezza > 0 && (
                    <p>
                      {t('Altezza')} {props.values?.posizioni[0]?.altezza}
                    </p>
                  )}
                  <p>
                    {t('Larghezza')} {props.values?.posizioni[0]?.larghezza}
                  </p>
                  {!props.values.dirty
                    ? props.values?.posizioni[0]?.personalizzazione?.accetta_pantone &&
                      props.values?.posizioni[0]?.pantoni_codici?.map((pantone, index) => (
                        <p key={`posizione-1-pantone-${index}`}>
                          {t('Colore')} {index + 1} {pantone}
                        </p>
                      ))
                    : props.values?.posizioni[0]?.personalizzazione[0] !== undefined
                    ? props.values?.posizioni[0]?.personalizzazione[0][0]?.accetta_pantone &&
                      props.values?.posizioni[0]?.pantoni_codici.map((pantone, index) => (
                        <p key={`posizione-1-pantone-${index}`}>
                          {t('Colore')} {index + 1} {pantone}
                        </p>
                      ))
                    : null}
                </div>
              )}
              {props.values?.posizioni?.length > 1 && (
                <div>
                  <strong>{t('Posizione 2')}</strong>
                  <p>{props.values.posizioni[1]?.tecnica?.nome}</p>
                  <p>{props.values.posizioni[1]?.posizione?.nome}</p>
                  {props.values?.posizioni?.[1]?.altezza > 0 && (
                    <p>
                      {t('Altezza')} {props.values.posizioni[1]?.altezza}
                    </p>
                  )}
                  <p>
                    {t('Larghezza')} {props.values.posizioni[1]?.larghezza}
                  </p>
                  {!props.values.dirty
                    ? props.values.posizioni[1]?.personalizzazione?.accetta_pantone &&
                      props.values.posizioni[1]?.pantoni_codici.map((pantone, index) => (
                        <p key={`posizione-2-pantone-${index}`}>
                          {t('Colore')} {index + 1} {pantone}
                        </p>
                      ))
                    : props.values.posizioni[1]?.personalizzazione[0] !== undefined
                    ? props.values.posizioni[1]?.personalizzazione[0][0]?.accetta_pantone &&
                      props.values.posizioni[1].pantoni_codici.map((pantone, index) => (
                        <p key={`posizione-2-pantone-${index}`}>
                          {t('Colore')} {index + 1} {pantone}
                        </p>
                      ))
                    : null}
                </div>
              )}
            </div>
          )
        }
        setStep={setStep}
        stepNumber={2}
        Modificabile={step > 1 ? true : false}
        placeholder={t('Configurazione di Stampa')}
        open={step === 1 ? true : false}
      >
        <ConfigurazioneStampa
          props={props}
          step={step}
          setStep={setStep}
          obj={Obj}
          initialValues={initialValues}
          setFieldValue
          isPage={isPage}
          handleScroll={() => handleScrollRef(configurazioneStampaItemRef)}
        />
      </StepItem>

      <StepItem
        isDisabled={step < 2 ? true : false}
        recap={
          step > 2 && (
            <div>
              {props.values?.confezionamento_richiesto &&
              props.values.confezionamento_richiesto !== 'N' ? (
                <>
                  <p>
                    {props.values.posizioni[0]?.personalizzazione?.length > 0
                      ? props.values?.posizioni[0]?.personalizzazione[0][0]?.confezionamento
                      : props.values?.posizioni[0]?.personalizzazione?.confezionamento}
                  </p>
                  <p>{t('Con confezionamento')}</p>
                </>
              ) : (
                <p>{t('Nessun confezionamento')}</p>
              )}
            </div>
          )
        }
        setStep={setStep}
        Modificabile={step > 2 ? true : false}
        stepNumber={3}
        placeholder={t('Tipo confezionamento')}
        open={step === 2 ? true : false}
      >
        <TipoConfezionamento props={props} step={step} setStep={setStep} obj={Obj} />
      </StepItem>

      <StepItem
        isDisabled={step < 3 ? true : false}
        recap={
          step > 3 && props.values?.files ? (
            <p>{t('Loghi caricati correttamente')}</p>
          ) : isPage && withLogoFromProps ? (
            <p>{t('Loghi caricati correttamente')}</p>
          ) : (
            <p>{t('Nessun logo caricato')}</p>
          )
        }
        setStep={setStep}
        Modificabile={step > 3 ? true : false}
        stepNumber={4}
        placeholder={t('Caricamento loghi')}
        open={step === 3 ? true : false}
      >
        <CaricamentoLoghi step={step} setStep={setStep} props={props} setReload={setReload} />
      </StepItem>

      <StepItem
        isDisabled={step < 4 ? true : false}
        recap={step > 4 && <p>{props.values?.nome_lavorazione}</p>}
        setStep={setStep}
        Modificabile={step > 4 ? true : false}
        stepNumber={5}
        placeholder={t('Nome Lavorazione')}
        open={step === 4 ? true : false}
      >
        <NomeLavorazione props={props} step={step} setStep={setStep} obj={Obj} />
        {/* //! Attenzione */}
        {/* Questa casistica serve per elaborare nel modo corretto le posizioni della personalizzazione che arrivano dalla fetch */}
        {/* Nel caso si dovesse incominciare la modifica da un punto diverso rispetto allo step 2 */}
        {isPage
          ? Object.values(props?.errors).length > 0 &&
            step === 4 && (
              <div style={{ display: 'none' }}>
                <ConfigurazioneStampa
                  props={props}
                  step={step}
                  setStep={setStep}
                  obj={Obj}
                  initialValues={initialValues}
                  setFieldValue
                  isPage={isPage}
                  handleScroll={() => handleScrollRef(configurazioneStampaItemRef)}
                />
              </div>
            )
          : null}
      </StepItem>

      <div className="form__personalizzazione__submit">
        <Button
          label={t('Annulla personalizzazione')}
          onClick={() => setShowModal(true)}
          variant="ghost"
        />

        {!ErroreQuantita ? (
          step > 4 && (
            <Button
              icon_name="clipboard"
              icon_size="24"
              icon={<Clipboard />}
              icon_pos="left"
              variant="primary"
              label={
                isPage
                  ? t('Conferma e Modifica la personalizzazione')
                  : t('Conferma e Procedi con il Preventivo')
              }
              type="submit"
              onClick={() => {
                props.handleSubmit()
                const first_articolo =
                  props?.values?.prodotto?.articoli.length > 0
                    ? props?.values?.prodotto?.articoli[0]
                    : null
                trackingGAEventProdotto(
                  'customization_complete',
                  'c_step6_personalizzazione_confermata',
                  undefined,
                  first_articolo?.titolo || '',
                  props?.values?.prodotto?.codice || ''
                )
              }}
              bg={Object.keys(props.errors).length > 0 && 'gray'}
            />
          )
        ) : (
          <Alert
            placeholder={t(
              'è presente un errore nelle quantità dei prodotti che si stanno personalizzando'
            )}
            variant="default"
          ></Alert>
        )}
      </div>
    </>
  )
}

const FormPersonalizzazione = ({
  personalizzazioneId,
  initialValuesFromProps,
  isPage,
  prodottoId,
  children,
  articoliQuantita,
  setShowPersonalizzaForm,
  AddToCart,
  ErroreQuantita,
  withLogoFromProps,
  prodotto,
  goBack,
  setReload,
}) => {
  const [initialValues, setInitialValues] = useState()
  const [step, setStep] = useState(isPage && initialValuesFromProps ? 5 : 0)
  const [Obj, setObj] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [Edited, setEdited] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const t = useTrans()
  const router = useRouter()

  useEffect(async () => {
    try {
      const params = { lang: router.locale }
      const response = await api.get(`${PRODOTTI}${prodottoId}${PERSONALIZZAZIONI}`, { params })

      const personalizzazione = await response.data
      setObj(personalizzazione)

      // ! Importante per inizializzare l'obj in fase di Edit
      initialValuesFromProps && setInitialValues(initialValuesFromProps)
      initialValuesFromProps && setStep(1)
      initialValuesFromProps && setStep(5)
    } catch (error) {
      console.log(error)
    }
  }, [])

  const MakePayload = async (values) => {
    const params = {
      nome_lavorazione: values.nome_lavorazione,
      stesso_logo: values.stesso_logo,
      confezionamento_richiesto: values.confezionamento_richiesto,
      posizioni: values.posizioni,
    }
    const files = values?.files ? Object.values(values?.files) : null

    isPage
      ? api
          .put(`${PERSONALIZZAZIONICARRELLO}${personalizzazioneId}/`, params)
          .then((response) => {
            files?.length > 0 &&
              response.data?.posizioni.forEach(
                async (posizione, index) =>
                  await _uploadLoghi({
                    id: posizione.id,
                    file_to_upload: files[index],
                    setLoading: setIsUploading,
                  })
                    .then((res) => setReload?.(true))
                    .catch((err) => console.log(err.message))
              )
            displayNotification(
              'success.pers.edit',
              t('Hai Modificato con successo la personalizzazione'),
              'success'
            )
            setEdited(true)
          })
          .catch((err) => {
            displayNotification('error.pers.edit', t('Qualcosa è andato storto'), 'error')
            Sentry.captureException(err)
          })
      : api
          .post(`${PERSONALIZZAZIONICARRELLO}`, params)
          .then((response) => {
            AddToCart(articoliQuantita, response.data.id)
            // ! Una volta creata la personalizzazione viene caricato il logo per ogni posizione
            files &&
              response.data?.posizioni.forEach(
                async (posizione, index) =>
                  await _uploadLoghi({
                    id: posizione.id,
                    file_to_upload: files[index],
                    setLoading: setIsUploading,
                  })
                    .then((res) => setReload?.(true))
                    .catch((err) => console.log(err.message))
              )
          })
          .catch((err) => {
            Sentry.captureException(err)
          })
  }
  return (
    <Formik
      validateOnBlur={true}
      validateOnChange={true}
      initialValues={
        isPage && initialValuesFromProps
          ? initialValuesFromProps
          : {
              personalizzazione: null,
              posizioni: [{}],
              confezionamento_richiesto: null,
              nome_lavorazione: null,
              stesso_logo: true,
              prodotto: prodotto ? prodotto : undefined,
            }
      }
      validationSchema={yup.object().shape({
        nome_lavorazione: yup
          .string()
          .min(3, t('Minimo 3 caratteri'))
          .required(t('Campo obbligatorio'))
          .max(18, t('Massimo 18 caratteri'))
          .nullable(),
        stess_logo: yup.bool(),
        confezionamento_richiesto: yup.bool().required(),
        posizioni: yup
          .array()
          .of(
            yup.object().shape({
              AltezzaZero: yup.bool(),
              altezza: yup.number().when('AltezzaZero', {
                is: true,
                then: yup.number().notRequired(t('Solo numeri positivi')),
                otherwise: yup
                  .number()
                  .required(t('Campo obbligatorio'))
                  .moreThan(0, t('Solo numeri positivi')),
              }),
              larghezza: yup
                .number()
                .required(t('Campo obbligatorio'))
                .positive(t('Solo numeri positivi')),
              pantoni_codici: yup.object().nullable(true),
              personalizzazione: yup.array(),
              personalizzazione_id: yup.number().required(),
            })
          )
          .required()
          .min(1)
          .max(2),
      })}
      onSubmit={(values, { resetForm }) => {
        MakePayload(values).then(() => {
          // No reset se siamo in modifica personalizzazione da carrello
          if (!isPage) {
            try {
              resetForm()
            } catch (error) {
              console.log(error)
              Sentry.captureException(error)
            }
          }
          setShowPersonalizzaForm && setShowPersonalizzaForm(false)
        })
      }}
    >
      {(props) => (
        <>
          <div className="form__personalizzazione__header">
            <h1>{t('Personalizzazione')}</h1>
            <div className="form__personalizzazione__header__content">{children}</div>
          </div>
          <div>
            {_renderStep(
              step,
              props,
              setStep,
              Obj,
              setShowModal,
              isPage,
              initialValues,
              ErroreQuantita,
              withLogoFromProps,
              prodotto,
              setReload
            )}
            {process.env.NODE_ENV === 'development' && (
              <>
                <strong style={{ color: 'red' }}>
                  Errori Form:{JSON.stringify(props.errors, null, 2)}
                </strong>
                <br />
                <strong style={{ color: 'red' }}>
                  Errore Quantità: {ErroreQuantita?.toString()}
                </strong>
              </>
            )}
          </div>

          <NewModal
            alert={true}
            visible={showModal}
            onClose={() => setShowModal(false)}
            title={t('Sei sicuro di voler annullare la personalizzazione?')}
            text={t("Cliccando su 'Conferma e procedi' perderai la configurazione creata.")}
            actions={[
              <Button
                label={t('Annulla e torna indietro')}
                variant="primary"
                size="medium"
                onClick={() => {
                  const first_articolo =
                    props?.values?.prodotto?.articoli.length > 0
                      ? props?.values?.prodotto?.articoli[0]
                      : null
                  trackingGAEventProdotto(
                    'customization_delete',
                    'annulla',
                    undefined,
                    first_articolo?.titolo || '',
                    props?.values?.prodotto?.codice || ''
                  )
                  setShowModal(false)
                }}
              />,
              <Button
                label={t('Conferma e procedi')}
                variant="secondary"
                size="medium"
                onClick={() => {
                  setStep(0)
                  props.resetForm()
                  setShowModal(false)
                  const first_articolo =
                    props?.values?.prodotto?.articoli.length > 0
                      ? props?.values?.prodotto?.articoli[0]
                      : null
                  trackingGAEventProdotto(
                    'customization_delete',
                    'conferma_e_procedi',
                    undefined,
                    first_articolo?.titolo || '',
                    props?.values?.prodotto?.codice || ''
                  )
                  goBack && router.push('/cart/')
                  !isPage ? setShowPersonalizzaForm(false) : router.push('/cart/')
                }}
              />,
            ]}
          />

          <NewModal
            visible={Edited}
            onClose={() => setEdited(false)}
            title={t('Hai Modificato con successo la Personalizzazione')}
            actions={[
              <Button
                variant="secondary"
                label={t('Continua a Modificare')}
                onClick={() => setEdited(false)}
              />,
              <Link href="/cart">
                <a>
                  <Button label={t('Torna al carrello')} variant="primary" />
                </a>
              </Link>,
            ]}
          />
        </>
      )}
    </Formik>
  )
}

export default React.memo(FormPersonalizzazione)
